import { Badge } from '@cibli/shared';
import { useTranslation } from 'react-i18next';

type EmploymentTypeBadgeProps = {
  employmentType: string;
  variant?: 'default' | 'secondary' | 'outline' | 'destructive';
  className?: string;
};

/**
 * Display employment type in a consistent badge with translation support.
 * Mirrors ContractTypeBadge behaviour for visual consistency.
 */
export const EmploymentTypeBadge = ({
  employmentType,
  variant,
  className,
}: EmploymentTypeBadgeProps) => {
  const { t } = useTranslation();
  const defaultClassName = variant ? '' : 'bg-gray-200 text-black h-7 rounded-sm';

  return (
    <Badge variant={variant} className={className || defaultClassName}>
      {t(`dashboard.jobs.filters.employmentTypeOptions.${employmentType}`, {
        defaultValue: employmentType,
      })}
    </Badge>
  );
};
